/**
 * To support the use of union types in Fragments, we need to specify
 * the super type -> sub-type relationships.
 * See: https://www.apollographql.com/docs/react/data/fragments#defining-possibletypes-manually
 */

export const typeConversions = {
  DataExtractionFieldBaseDto: [
    'DataExtractionFieldHeaderDto',
    'DataExtractionFieldTextDto',
    'DataExtractionFieldSingleSelectDto',
    'DataExtractionFieldMultipleSelectDto',
  ],
  DataExtractionValueBaseDto: [
    'DataExtractionValueTextDto',
    'DataExtractionValueSingleSelectDto',
    'DataExtractionValueMultipleSelectDto',
  ],
  ReferenceEventPayload: [
    'UploadEventPayload',
    'DuplicateEventPayload',
    'ScreeningEventPayload',
    'FullTextReviewEventPayload',
    'DataExtractionEventPayload',
    'CommentEventPayload',
    'TagEventPayload',
  ],
};
